const config = {
    // API_URL: "http://localhost/tycah/",
    API_URL: "https://tycahapi.codexrush.com/",
    // API_URL: "https://api.chemizon.internationalwebtech.com/",
  };
  
  export default config;
  